module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_pp1_9016.8cf272c4.png";